/* @generated */

// src/mini/empty-box.tsx
import * as React from "react";

// src/index.css.ts
var miniIllustrationStyle = "dig-13or4mr0_4-3-0";

// src/mini/empty-box.tsx
var EmptyBoxMini = ({ altText, ...rest }) => {
  const classNames = `dig-Illustration ${miniIllustrationStyle} dig-Illustration-mini`;
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      role: "presentation",
      ...rest,
      className: classNames,
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("title", null, altText),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M19.323 122.236c-.497-6.299.39-12.372.156-18.464-.364-9.185-.509-18.401-.587-27.578-.023-2.643-.587-3.915-3.62-3.74-4.611.27-9.245.071-14.952.071 1.988-3.199 18.102-23.612 18.102-23.612s60.95-.392 91.232-.442c1.284 0 13.605 16.443 18.666 23.882h-18.368c0 5.481-.126 10.66.023 15.849.294 10.105.372 33.443.372 33.443s-89.772.591-91.024.591Z",
        fill: "#9B6400"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M59.966 54.14c-3.26 2.435-7.703 8.03-11.01 12.528-2.643 3.59-4.56 6.48-4.56 6.48s-3.253-.153-3.249-.16c-6.102.583-22.682-.29-22.682-.29a17.566 17.566 0 0 0 .04 4.02c.3 2.283.43 3.72.43 3.72s24.228 1.773 26.956 0c1.358-.881 6.802-11.589 6.802-11.589s6.69-10.779 7.273-14.71Zm49.985 18.229c-4.548.145-12.356-.345-16.83.9-3.796.122-7.722 0-11.628.078-1.272-1.401-18.085-23.2-18.085-23.2a22.99 22.99 0 0 0-1.002 8.695c-.657 19.364.192 39.543.983 58.837-.028.755-.196 2.862.602 3.398 1.41 4.088 1.979-4.032 1.818-4.173-.352-21.745-1.753-49.666-.602-58.977.18-1.437-.852-3.349-.394-4.48 1.828 2.227 6.276 10.876 7.11 11.596.035 1.884 8.904 14.44 8.904 14.44s10.423-.224 14.333-.11c3.022-.72 11.962-.302 14.263-.364.012-2.666.525-6.636.528-6.64Z",
        fill: "#1E1919"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M66.244 34.274c-1.738-7.572-.028-13.918 1.31-20.273a48.83 48.83 0 0 1 1.88-6.84c.246-.669 1.624-1.565 2.113-1.377 1.084.41 2.842 1.566 2.74 2.2-1.296 8.805-2.771 17.599-8.043 26.29Zm24.494-9.31c-3.993 6.805-8.787 11.052-15.484 14.772 2.395-6.875 6.168-11.663 10.689-15.825.622-.572 2.826.58 4.795 1.053Zm-38.73 16.694C44.514 37.7 41.3 30.116 37.041 23.05c1.28.45 3.038.521 3.754 1.422 4.239 5.344 8.22 10.876 12.313 16.345l-1.1.842ZM47.128 8.81c3.04-.348 4.618.391 5.377 2.98 1.566 5.3 3.32 10.539 4.58 15.997-5.01-5.29-7.593-11.824-9.957-18.977Z",
        fill: "currentColor"
      }
    )
  );
};
export {
  EmptyBoxMini
};
